import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="h-12 w-12 text-gray-500" />
          </div>
          
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Paiement annulé
          </h2>
          
          <p className="text-gray-600 mb-6">
            Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.
          </p>
          
          <div className="space-y-3">
            <Button 
              onClick={() => navigate(-1)} 
              className="w-full"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Réessayer le paiement
            </Button>
            
            <Button 
              onClick={() => navigate('/member')} 
              variant="outline"
              className="w-full"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Retour à mon espace
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
